/**
 * 数据处理层
 */
import { getPatrolData, addOperationProject, searchOperationProject, updateOperationProject, getAllRepair, getRepairCount, deleteOperationProject, getAllOpsFaultType } from './apis/operatoin.js'
import getModules from './apis/typeModule'
import {
    deviceStatisticsData,
    deviceWarnStatisticsData,
    deviceDiscreteStatisticsData,
    getWarnStatistics, typeStatistics
} from './apis/statistics'
import {
    storage,
    deepClone
} from '../utils/tools'

import { TypeModuleArgument } from './apis/moduleConfig'

import weathApi from "./apis/weather";

import {
    _monitor,
    _boolean,
    _enum,
    CTRL_MODE,
    _string
} from '../types/module.js'

import { getOverView } from "./apis/project";

let self = null;

/**
 * @class
 * @classdesc 数据处理中心
 */
export default class DPC {
    constructor(proc) {
        this.proc = proc;
        this.data = proc.data;
        this.Device = proc.data.device;
        self = this;
        if (proc.data.isLogined && this.Device) {
            this._getModules()
        } else {
            // 监听device的数据
            proc.watch('device', (device) => {
                this.Device = device;
                this._getModules();
            })
        }
        this.mqttData = proc.data.mqttData;

    }

    /**
     * 运维
     */
    operation = {
        // 添加
        addProject(data, type) {
            if (type == 'add') {
                return addOperationProject(data)
            } else if (type == 'update') {
                return updateOperationProject(data)
            }
        },

        // 搜索
        searchProject(keyword) {
            return searchOperationProject(keyword)
        },

        /**
         * @enum
         * @readonly
         * @property {number} order 派单
         * @property {number} onWay 维修在途
         * @property {number} other 表示第三方维修
         * @property {number} accessories 等待配件
         * @property {number} audit 表示等待审核
         * @property {number} success 表示完成
         */
        RepairStatus: {
            'order': 0,
            'onWay': 1,
            'other': 2,
            'accessories': 3,
            'audit': 4,
            'success': 5,
        },

        async getAllRepair(data) {
            let res = await getAllRepair({
                RepairType: 0,
                ...data
            })
            return res;
        },

        async getRepairCount() {
            let res = await getRepairCount()

            return res.data;
        },

        /**
         * 删除运维项目
         * @param {any} id 
         * @returns 
         */
        async removeOpsProject(id) {
            let res = await deleteOperationProject(id)
            return res.data
        },

        /**
         * 获取所有故障类型
         * @returns 
         */
        async getAllOpsFaultType() {
            let res = await getAllOpsFaultType()
            return res.data || []
        },
        /**
         * 获取所有巡检数据
         */
        async getAllPatrolData(params = { PageNo: 1, PageSize: 20, BeginTime: self.threeMonthAgo(6), EndTime: new Date() }) {
            return new Promise((resolve, reject) => {
                let that = this;
                // 当前页
                let currentPage = params.PageNo || 1;
                // 总分页数
                let totalPage = 0;
                let size = params.PageSize || 20;
                let start = params.BeginTime || self.threeMonthAgo(6);
                let end = params.EndTime || new Date();
                let all = []
                let func = async function (_param) {
                    let res = await that.getPatrolData({
                        PageNo: currentPage,
                        PageSize: size,
                        BeginTime: _param.start,
                        EndTime: _param.end
                    }).catch(err => {
                        reject(err)
                    })
                    currentPage++;
                    totalPage = res.totalPage;
                    let data = res.data || []

                    data.forEach(item => {
                        const { devicePatrol, productData, techniquePatrol, waterAnalysis } = item;
                        item.devicePatrol = devicePatrol ? JSON.parse(devicePatrol) : [];
                        item.productData = productData ? JSON.parse(productData) : [];
                        item.techniquePatrol = techniquePatrol ? JSON.parse(techniquePatrol) : [];
                        item.waterAnalysis = waterAnalysis ? JSON.parse(waterAnalysis) : [];
                    })
                    all = all.concat(data)
                    if (currentPage <= totalPage) {
                        func(_param)
                    } else {
                        func = null;
                        resolve(all)
                    }
                }
                func({ start, end });
            })

        },
        /**
         * 获取巡检数据
         * @param {object} data 
         * @returns 
         */
        async getPatrolData(data) {
            let res = await getPatrolData(data)
            return res
        }
    }


    // 模块原始数据
    originalModulesData = [];
    /**
     * 获取mqtt数据
     * @returns {Promise<any>}
     */
    getMqttData() {
        return new Promise((resolve, reject) => {
            this.proc.watch('mqttData', (data) => {
                // 数据有更新时重新绑定数据
                this.mqttData = data;
                this.bindInitModules(data);
                resolve(data);
            })
        })
    }

    /**
     * 字符串转换json
     * @param {string} str 
     * @returns 
     */
    stringToJson(str) {
        if (typeof str == 'string') {
            try {
                return JSON.parse(str);
            } catch (e) {
                return str;
            }
        } else {
            return str;
        }
    }

    /**
     * 获取指定天数之前的日期
     * @param {number} days 
     * @returns 
     */
    threeDaysAgo(days = 3) {
        let date = new Date();
        date.setTime(date.getTime() - 1000 * 60 * 60 * 24 * days);
        return date
    }
    /**
         * 获取指定月之前的日期
         * @param {number} month 
         * @returns 
         */
    threeMonthAgo(month = 3) {
        let date = new Date()
        date.setMonth(date.getMonth() - month)
        date.setDate(1)
        return date
    }

    /**
     * 时间格式化
     * @param {number} time 
     * @returns 
     */
    formatTime(time) {
        let date = new Date(time);
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    }

    /**
     * 设备报警信息
     * @returns {Promise<any>}
     */
    async deviceWarnInfo(begin = this.threeDaysAgo(3), end = new Date(), projectId = 0) {

        let data = await deviceWarnStatisticsData({
            BeginTime: begin,
            EndTime: end,
            ProjectId: projectId || 0,
            State: 0,
            PageSize: 100
        })
        data.forEach(item => {
            item.dt = this.formatTime(item.dt)
        })
        return data;
    };

    /**
     * 获取设备的分类统计数据
     * @param {string} projectId 
     */
    async bindOverView(projectId = 0) {
        let groupId = this.data.userinfo.groupId;
        let res = await getOverView(groupId, projectId)
        return res.data;
    }

    /**
     * 分类统计报警数据
     * @param {*} data 
     * @returns 
     */
    async bindWarnStatistics(data) {
        let res = await getWarnStatistics(data)
        return res;
    }

    /**
     * 离散统计
     * @returns {Promise<any>}
     */
    async bindDiscreteStatisticsData() {
        let Device = this.Device;
        let data = await deviceDiscreteStatisticsData(this.data.userinfo.groupId, {
            BeginTime: this.threeDaysAgo(2),
            EndTime: this.threeDaysAgo(1),
            DeviceSn: Device ? Device.deviceSn : 0
        })

        if (!data) {
            return Promise.resolve({});
        }
        let allStatistics = [];
        let statisticsData = [];
        data.forEach(item => {
            item.data = JSON.parse(item.data)
            if (item.data?.Data) {
                item.data.Data.forEach(sel => {
                    sel.Date = item.date;
                    sel.deviceName = item.deviceName;
                    sel.deviceSn = item.deviceSn;
                    sel.id = item.id;
                    sel.projectId = item.projectId;
                    sel.typeId = item.typeId;
                    sel.Format = JSON.parse(sel.Format||'{}');
                    sel.SUnit = JSON.parse(sel.SUnit||'{}');
                    sel.Unit = JSON.parse(sel.Unit||'{}');
                    sel.Values = JSON.parse(sel.Values||'0');
                    allStatistics.push(sel)
                })
            }
        })
        allStatistics.sort((a, b) => {
            return new Date(a.Date).getTime() - new Date(b.Date).getTime()
        })


        allStatistics.forEach(item => {
            let sdata = statisticsData.find((item2) => item2.key == item.Key)
            if (!sdata) {
                let obj = {
                    name: item.Name,
                    id: item.id,
                    key: item.Key,
                    data: [item]
                }
                statisticsData.push(obj)
            } else {
                sdata.data.push(item)
            }
        })
        return statisticsData
    }

    // 获取统计信息
    /**
     * 
     * @param {Date} BeginTime 
     * @param {Date} EndTime 
     * @returns {Promise<any>}
     */
    async bindStatistics(BeginTime, EndTime, _data = {}) {

        let params = {
            IsDevice: true,
            DeviceSn: _data.DeviceSn ?? this.Device.deviceSn,
            ProjectId: _data.ProjectId ?? this.Device.projectId
        }
        if (Object.keys(_data).length) {
            params = { ...params, ..._data };

        }
        let data = await deviceStatisticsData(this.data.userinfo.groupId, {
            BeginTime,
            EndTime,
            ...params
        }).catch(err => {
            Promise.reject(err)
        })

        let statisticsData = [];
        let allStatistics = [];
        data.forEach(item => {
            item.data = JSON.parse(item.data)
            if (item.data?.Data) {
                // 重构数据格式
                item.data.Data.forEach(sel => {
                    sel.Date = item.date;
                    sel.deviceName = item.deviceName;
                    sel.deviceSn = item.deviceSn;
                    sel.id = item.id;
                    sel.projectId = item.projectId;
                    sel.typeId = item.typeId;
                    sel.Format = sel.Format ? JSON.parse(sel.Format) : sel.Format;
                    sel.SUnit = sel.SUnit ? JSON.parse(sel.SUnit) : sel.SUnit;
                    sel.Unit = sel.Unit ? JSON.parse(sel.Unit) : sel.Unit;
                    allStatistics.push(sel)
                })
            }
        })

        allStatistics.sort((a, b) => {
            return new Date(a.Date).getTime() - new Date(b.Date).getTime()
        })


        allStatistics.forEach(item => {
            let sdata = statisticsData.find((item2) => item2.key == item.Key)

            if (!sdata) {
                let obj = {
                    name: item.Name,
                    id: item.id,
                    key: item.Key,
                    data: [item]
                }
                statisticsData.push(obj)
            } else {
                sdata.data.push(item)
            }
        })
        return statisticsData
    }

    /**
     * 获取统计的类型
     * @param {string|number} typeId typeid
     */
    async bindTypeStatistics(typeId = null, data = { BeginTime: this.threeDaysAgo(7), EndTime: new Date() }) {
        if (!this.Device) return;
        let _typid = typeId ?? this.Device.typeId;
        const res = await typeStatistics(_typid, { PageSize: 100 });
        const statisticsData = await this.bindStatistics(data.BeginTime, data.EndTime, { ...data });

        res.forEach(item => {
            if (!item.statisticsData) {
                item.statisticsData = []
            }
            statisticsData.forEach(statisticsItem => {
                if (item.dataKey == statisticsItem.key) {
                    item.statisticsData = statisticsItem.data
                }
            })
        })
        return JSON.parse(JSON.stringify(res))
    }
    /**
     * 开关控制模块
     */
    controls = [];
    /**
     * 监控模块
     */
    monitor = [];
    /**
     * 设备控制模式
     */
    ctrlMode = [];
    // 获取所有模块
    async _getModules() {
        const device = this.Device;
        if (!device) return;
        let res = await getModules(device.typeId || device.TypeId)
        let modules = []; //控制模块
        let ctrlMode = []; //控制模式

        res.forEach(_module => {
            modules = [...modules, ..._module.controls]
            _module.arguments.forEach(arg => {
                arg.defineFormat = arg.defineFormat && JSON.parse(arg.defineFormat);
                if (arg.category == CTRL_MODE) {
                    arg.CurrentValueKey = arg.SettingValueKey = arg.dataKey;
                    arg.currentValue = null;
                    ctrlMode.push(arg);
                }
            })
        })
        modules.forEach(_module => {
            _module.format = this.stringToJson(_module.format);
            _module.formula = this.stringToJson(_module.formula);
            _module.unit = this.stringToJson(_module.unit);
            // 预设值
            _module.SettingValueKey = _module.formula.SettingValue;
            _module.CurrentValueKey = _module.formula.CurrentValue;
            _module.settingValue = null;
            _module.currentValue = null;
            _module.displayValue = null;
        })
        this.allModules = modules;
        // 监控模块
        let monitor = modules.filter(item => item.showType === _enum || item.showType === _monitor)
        // 控制模块
        let controls = modules.filter(item => item.showType === _boolean)

        this.controls = controls;
        this.monitor = monitor;
        this.ctrlMode = ctrlMode;

        this.proc.setData({
            controls,
            monitor,
        })
        if (!this.mqttData) {
            this.getMqttData()
        } else {
            this.bindInitModules(this.mqttData)
        }
        // 保存原始数据
        this.originalModulesData = res;
    }

    // 绑定初始化数据
    bindInitModules(mqttdata) {
        // 绑定监控模块的值
        this.bindModule(this.allModules, mqttdata)
        this.bindCtrlMode(this.ctrlMode, mqttdata)
    }

    // 绑定控制模式的值
    bindCtrlMode(modeObj, mqttdata) {
        let data = mqttdata.data;
        if(!data)return;
        let uuid = mqttdata.uuid
        modeObj.forEach(item => {
            item.uuid = uuid;
            item.currentValue = item.defineFormat ? item.defineFormat[data[item.dataKey]] : data[item.dataKey];
        })
        this.proc.data.ctrlMode = modeObj;
    }

    get ctrlModes() {
        return this.proc.data.ctrlMode;
    }

    // 绑定模块的值
    bindModule(modules, mqttData) {
        let data = mqttData.data;
        if(!data)return;
        let uuid = mqttData.uuid;
        modules.forEach(item => {
            let formula = item.formula;
            let format = item.format;
            // item.currentValue = null;
            item.uuid = uuid;
            // 当存在反馈项逻辑运算
            let hoCurrentValue, yuCurrentValue;
            if (formula.CurrentValue && (formula.CurrentValue.indexOf("||") > -1 || formula.CurrentValue.indexOf("&&") > -1)) {

                hoCurrentValue = formula.CurrentValue.split("||");
                yuCurrentValue = formula.CurrentValue.split("&&");
                hoCurrentValue.forEach((value, index) => {
                    if (value.indexOf('&&') > -1) {
                        hoCurrentValue.splice(index, 1);
                    }
                })
                yuCurrentValue.forEach((value, index) => {
                    if (value.indexOf('||') > -1) {
                        yuCurrentValue.splice(index, 1);
                    }
                })

                // 当反馈项有逻辑运算时
                if (!item.currentValue) {
                    item.currentValue = {};
                }
                if (hoCurrentValue.length > 1) {
                    item.currentValue['||'] = hoCurrentValue
                }
                if (yuCurrentValue.length > 1) {
                    item.currentValue['&&'] = yuCurrentValue
                }
            }
            const setVal = () => {
                // 枚举mqtt的混合逻辑
                if (Object.prototype.toString.call(item.currentValue) === '[object Object]') {

                    let flag = true;
                    // 与的逻辑
                    if (item.currentValue['&&']) {
                        flag = item.currentValue['&&'].every((key) => {
                            return data[key] == true;
                        })
                    }
                    // 或的逻辑
                    if (item.currentValue['||'] && flag) {
                        flag = item.item.currentValue['||'].some(key => {
                            return data[key] == true;
                        })
                    }
                    // 当前值
                    flag ? item.displayValue = 1 : item.displayValue = 0;
                } else {

                    item.displayValue = item.currentValue ? format[item.currentValue] : format[item.settingValue]
                }
            }
            // 反馈值
            item.currentValue = formula.CurrentValue ? data[formula.CurrentValue] : 0
            // 设定值
            item.settingValue = formula.SettingValue ? data[formula.SettingValue] : 0

            // string类型无displayValue值，通过反馈值和设定值来展示

            if (format) {
                function optimizeCode(item) {

                    return item.currentValue !== undefined ? item.currentValue : item.settingValue || 0;
                }
                switch (item.showType) {
                    case _enum:
                        // 枚举mqtt的混合逻辑
                        // setVal()
                        item.displayValue = format[optimizeCode(item)]
                        break;
                    case _monitor:
                        if(format[optimizeCode(item)]){
                            item.displayValue = format[optimizeCode(item)];
                        }else{
                            item.displayValue = (Number(optimizeCode(item)) / Number(format.step || 1)).toFixed(2);
                        }
                        
                        break;
                    case _boolean:
                        setVal()
                        break;
                    case _string:
                        try {
                            item.displayValue = Number(optimizeCode(item)).toFixed(2);
                        } catch (error) {
                            item.displayValue = optimizeCode(item)
                        }

                        break;
                }
            }

        })
        let monitor = modules.filter(item => item.showType === _enum || item.showType === _monitor)
        // 控制模块
        let controls = modules.filter(item => item.showType === _boolean)

        this.controls = controls;
        this.monitor = monitor;

        this.proc.setData({
            controls,
            monitor,
        })

        this.proc.data.modules = modules;
    }

    /**
     * 获取所有模块数据
     */
    get modules() {
        return this.proc.data.modules
    }

    /**
     * 获取城市天气
     * @param {string} cityID 城市代码
     */
    async getWeather(cityID) {
        return fetch('https://api.yytianqi.com/observe?city=CH310101&key=v5909nmd8hscaskp')
            .then(function (response) {
                return response.json()
            })
        // return await weathApi(cityID)
    }

    // 获取模块配置数据

    async getTypeModuleArgument() {
        console.log('所有模块数据', this.allModules)
        // let data =await TypeModuleArgument(ModuleId)
    }

    /*
        ** 时间戳显示为多少分钟前，多少天前的处理
        ** eg.
        ** console.log(dateDiff(1411111111111));  // 2014年09月19日
        ** console.log(dateDiff(1481111111111));  // 9月前
        ** console.log(dateDiff(1499911111111));  // 2月前
        ** console.log(dateDiff(1503211111111));  // 3周前
        ** console.log(dateDiff(1505283100802));  // 1分钟前
        */
    dateDiff(timestamp) {
        // 补全为13位
        var arrTimestamp = (timestamp + '').split('');
        for (var start = 0; start < 13; start++) {
            if (!arrTimestamp[start]) {
                arrTimestamp[start] = '0';
            }
        }
        timestamp = arrTimestamp.join('') * 1;

        var minute = 1000 * 60;
        var hour = minute * 60;
        var day = hour * 24;
        var halfamonth = day * 15;
        var month = day * 30;
        var now = new Date().getTime();
        var diffValue = now - timestamp;

        // 如果本地时间反而小于变量时间
        if (diffValue < 0) {
            return '不久前';
        }

        // 计算差异时间的量级
        var monthC = diffValue / month;
        var weekC = diffValue / (7 * day);
        var dayC = diffValue / day;
        var hourC = diffValue / hour;
        var minC = diffValue / minute;

        // 数值补0方法
        var zero = function (value) {
            if (value < 10) {
                return '0' + value;
            }
            return value;
        };

        // 使用
        if (monthC > 12) {
            // 超过1年，直接显示年月日
            return (function () {
                var date = new Date(timestamp);
                return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日';
            })();
        } else if (monthC >= 1) {
            return parseInt(monthC) + "月前";
        } else if (weekC >= 1) {
            return parseInt(weekC) + "周前";
        } else if (dayC >= 1) {
            return parseInt(dayC) + "天前";
        } else if (hourC >= 1) {
            return parseInt(hourC) + "小时前";
        } else if (minC >= 1) {
            return parseInt(minC) + "分钟前";
        }
        return '刚刚';
    };
}